/**
 * @generated SignedSource<<49ff9d2c94ffebde858df1483eef04c3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ExperimentsGetSpeculativeDataQuery$variables = {
  userId: string;
};
export type ExperimentsGetSpeculativeDataQuery$data = {
  readonly userByPublicUserId: {
    readonly experimentsSpeculativeData: ReadonlyArray<{
      readonly flagName: string | null | undefined;
      readonly id: string;
      readonly modifiedOn: any | null | undefined;
      readonly payload: {
        readonly rootElement: any;
      } | null | undefined;
      readonly variantName: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type ExperimentsGetSpeculativeDataQuery = {
  response: ExperimentsGetSpeculativeDataQuery$data;
  variables: ExperimentsGetSpeculativeDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "publicUserId",
    "variableName": "userId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "ExperimentsSpeculativeDataNode",
  "kind": "LinkedField",
  "name": "experimentsSpeculativeData",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flagName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "variantName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "JsonDocument",
      "kind": "LinkedField",
      "name": "payload",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rootElement",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "modifiedOn",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExperimentsGetSpeculativeDataQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserNode",
        "kind": "LinkedField",
        "name": "userByPublicUserId",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExperimentsGetSpeculativeDataQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserNode",
        "kind": "LinkedField",
        "name": "userByPublicUserId",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6a742681294d6f38d94b70b6feef5e26",
    "id": null,
    "metadata": {},
    "name": "ExperimentsGetSpeculativeDataQuery",
    "operationKind": "query",
    "text": "query ExperimentsGetSpeculativeDataQuery(\n  $userId: String!\n) {\n  userByPublicUserId(publicUserId: $userId) {\n    experimentsSpeculativeData {\n      id\n      flagName\n      variantName\n      payload {\n        rootElement\n      }\n      modifiedOn\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "da1277468d299a01fa25a8b8a11f44aa";

export default node;
